<script setup lang="ts">
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import { adminLogin } from '../api';

const router = useRouter();
const username = ref('reviewer1');
const password = ref('reviewer123');
const loading = ref(false);

async function submit() {
  if (!username.value || !password.value) {
    ElMessage.warning('请输入用户名密码');
    return;
  }
  loading.value = true;
  try {
    await adminLogin(username.value, password.value);
    ElMessage.success('登录成功');
    router.push('/home');
  } catch (e) {
    const err = e as { message?: string; code?: string };
    ElMessage.error(err.message || err.code || '登录失败');
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <div class="login">
    <el-card class="card">
      <template #header>
        <div class="title">审核员后台 · 登录</div>
      </template>
      <el-form label-width="72px" @submit.prevent="submit">
        <el-form-item label="用户名">
          <el-input v-model="username" placeholder="reviewer1 (seed 默认)" autofocus />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="password" type="password" show-password placeholder="reviewer123" />
        </el-form-item>
        <el-button type="primary" :loading="loading" @click="submit" style="width: 100%">
          登录
        </el-button>
      </el-form>
      <div class="hint">
        开发期默认账号(<code>scripts/seed.ts</code>):<br />
        reviewer1 / reviewer123 ·
        admin1 / admin123456
      </div>
    </el-card>
  </div>
</template>

<style scoped>
.login { min-height: 100vh; display: flex; justify-content: center; align-items: center; background: #f5f5f7; }
.card { width: 440px; }
.title { font-size: 20px; font-weight: 600; }
.hint { margin-top: 16px; color: #86868b; font-size: 12px; line-height: 1.6; }
.hint code { background: #f5f5f7; padding: 1px 4px; border-radius: 3px; }
</style>
